
export class PagedList<T> {
    public content: T[];
    public number: number
    public size: number;
    public totalElements: number;
    public last: boolean;
    public totalPages: number;
    public first: boolean;
    public numberOfElements: number;
}